import { useEffect, useRef } from "react";

const useCombinedRefs = <T,>(...refs: Array<React.Ref<T> | null>): React.RefObject<T> => {
    const targetRef = useRef<T>(null);

    useEffect(() => {
        refs.forEach(ref => {
            if (!ref) return;

            if (typeof ref === 'function') {
                ref(targetRef.current);
            } else if (ref) {
                (ref as React.MutableRefObject<T | null>).current = targetRef.current;
            }
        });
    }, [refs]);

    return targetRef;
};

export default useCombinedRefs;